export default __webpack_public_path__ + "20aeaf4e8b627de58a2f7932e1381f28.svg";